import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const zktecoApi = axios.create({
  baseURL: `${API_BASE_URL}/zkteco`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token
zktecoApi.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
zktecoApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré, rediriger vers login
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const zktecoService = {
  // Agents
  getAllAgents: async () => {
    const response = await zktecoApi.get('/agents');
    return response.data;
  },

  getAgentById: async (agentId) => {
    const response = await zktecoApi.get(`/agents/${agentId}`);
    return response.data;
  },

  getAgentStatus: async (agentId) => {
    const response = await zktecoApi.get(`/agents/${agentId}/status`);
    return response.data;
  },

  registerAgent: async (agentData) => {
    const response = await zktecoApi.post('/agents/register', agentData);
    return response.data;
  },

  updateAgentStatus: async (agentId, status) => {
    const response = await zktecoApi.put(`/agents/${agentId}/status`, { status });
    return response.data;
  },

  deleteAgent: async (agentId) => {
    const response = await zktecoApi.delete(`/agents/${agentId}`);
    return response.data;
  },

  getAgentsByStatus: async (status) => {
    const response = await zktecoApi.get(`/agents/status/${status}`);
    return response.data;
  },

  // Attendance
  getPendingAttendance: async (page = 0, size = 50) => {
    const response = await zktecoApi.get('/attendance/pending', {
      params: { page, size },
    });
    return response.data;
  },

  getAttendanceByStatus: async (status) => {
    const response = await zktecoApi.get(`/attendance/status/${status}`);
    return response.data;
  },

  getAttendanceById: async (id) => {
    const response = await zktecoApi.get(`/attendance/${id}`);
    return response.data;
  },

  validateAttendance: async (id) => {
    const response = await zktecoApi.post(`/attendance/${id}/validate`);
    return response.data;
  },

  rejectAttendance: async (id, reason) => {
    const response = await zktecoApi.post(`/attendance/${id}/reject`, { reason });
    return response.data;
  },

  batchValidateAttendance: async (ids) => {
    const response = await zktecoApi.post('/attendance/batch-validate', { ids });
    return response.data;
  },
};

export default zktecoService;

